(function(exports) {
  var ss = exports.slideshare_object,
      utils = ss.utils,
      events = {
        clipCreated: 'clip:created',
        clipDeleted: 'clip:deleted',
        clipShared: 'clip:shared',
        clipMoved: 'clip:moved',
        clipboardCreated: 'clipboard:created'
      },
      selectors = {
        clipTopButton: '.clip-button-top',
        clipsToolbarActive: '.j-clips-toolbar:not(.inactive)',
        topClipboardOwner: '.top-clipboards-modal .author',
        topClipboardThumb: '.top-clipboards-modal .link-bg-img',
        topClipboardTitle: '.top-clipboards-modal .clipboard-url'
      };

  /**
   * Object that handles clipping tracking on the slideshow page
   */
  function Tracker() {
    this.$document = $(document);
    this.attachEventListeners();
  }

  /**
   * Binds all necessary event listeners
   */
  Tracker.prototype.attachEventListeners = function() {
    this.$document
      .on(events.clipCreated, function(e, data) {
        ss.clippingTracker.createClip(data.clip, data.clipboard.id);
      })
      .on(events.clipDeleted, function(e, data) {
        ss.clippingTracker.deleteClip(data.clip);
      })
      .on(events.clipMoved, function(e, data) {
        var clipId = data.clip.id,
            fromClipboardId = data.fromClipboard.id,
            toClipboardId = data.toClipboard.id;
        ss.clippingTracker.moveSingleClip(clipId, fromClipboardId, toClipboardId);
      })
      .on(events.clipShared, function(e, data) {
        ss.clippingTracker.shareClip(data.clip.id, data.shareType);
      })
      .on(events.clipboardCreated, function(e, data) {
        ss.clippingTracker.createClipboard(data.clipboard);
      });

    if (!utils.isUserAuthenticated()) {
      this.attachClickTracker('clipTopButton', 'clickClipButton');
    }

    this.attachClickTracker('clipsToolbarActive', 'clickSlideviewTopClipboardsOpen');
    this.attachClickTracker('topClipboardOwner', 'clickTopClipboardsClipboardOwner');
    this.attachClickTracker('topClipboardThumb', 'clickTopClipboardsClipboardThumb');
    this.attachClickTracker('topClipboardTitle', 'clickTopClipboardsClipboardTitle');
  };

  /**
   * Attaches a track method to be used when a click event is fired on a selector.
   * @param {String} selector The selector name
   * @param {String} trackMethod The track method to be used when a click event occurs
   */
  Tracker.prototype.attachClickTracker = function(selector, trackMethod) {
    this.$document.on('click', selectors[selector], function() {
      ss.clippingTracker[trackMethod]();
    });
  };

  /**
   * Does any leftover tracking after login
   */
  Tracker.prototype.trackAfterLogin = function() {
    var tracker = null,
        data = ss.after_login_clip_data,
        loggedIn = utils.isUserAuthenticated();

    if (loggedIn && data && !data.trackingComplete) {
      tracker = new ss.ClippingTracker({
        userIsOwner: true,
        trackingId: data.tracking_id
      });
      tracker.createClip(data.clip, data.clipboard.id);
      if (data.is_first_clip) {
        tracker.createClipboard(data.clipboard);
      }
      data.trackingComplete = true;
    }
  };

  /**
   * Returns the id currently used for tracking
   */
  Tracker.prototype.trackingId = function() {
    return ss.clippingTracker.trackingId;
  };

  utils.exports('clips.Tracker', Tracker);
}(window));
